import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
const Tab = ({ className, children })=>/*#__PURE__*/ React.createElement("div", {
        className: cx('Tab', className)
    }, children);
Tab.propTypes = {
    /**
	 * Content of tab
	 */ children: PropTypes.node,
    /**
	 * Custom class name
	 */ className: PropTypes.string,
    /**
	 * Whether is tab clickable
	 */ disabled: PropTypes.bool,
    /**
	 * True if tab is allowed to hide
	 */ hideable: PropTypes.bool,
    /**
	 * Label of tab which will be shown in tabs panel
	 */ label: PropTypes.node,
    /**
	 * Custom react node to be rendered instead of ListItem
	 */ listItemElement: PropTypes.node
};
export default Tab;
